var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_2600)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D6D332"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9167 16.9583H9.08342C7.33341 16.9583 6.16675 16.0833 6.16675 14.0417V9.95832C6.16675 7.91666 7.33341 7.04166 9.08342 7.04166H14.9167C16.6667 7.04166 17.8334 7.91666 17.8334 9.95832V14.0417C17.8334 16.0833 16.6667 16.9583 14.9167 16.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5075C11.51 12.5075 11.0142 12.3558 10.635 12.0467L8.8092 10.5883C8.62253 10.4367 8.58754 10.1625 8.7392 9.97585C8.89087 9.78918 9.16504 9.75418 9.3517 9.90585L11.1775 11.3642C11.6209 11.72 12.3734 11.72 12.8167 11.3642L14.6425 9.90585C14.8292 9.75418 15.1092 9.78335 15.255 9.97585C15.4067 10.1625 15.3775 10.4425 15.185 10.5883L13.3592 12.0467C12.9859 12.3558 12.49 12.5075 12 12.5075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_2600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3fcb7fd4c9054117ccb4059c6233c7d1.svg";
export { ForwardRef as ReactComponent };